import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TTicketingUserInvitation } from '../types/ticketing-user.type';

export const DeleteInvitationTicketingUserValidationSchema = z.object({
  invitationId: z.string({ message: 'Invitation ID is required' }).min(1),
});
export type TDeleteInvitationTicketingUserValidation = z.infer<typeof DeleteInvitationTicketingUserValidationSchema>;
export type TDeleteInvitationTicketingUserPayload = TDeleteInvitationTicketingUserValidation;
export type TDeleteInvitationTicketingUserResponse = ApiResponse<TTicketingUserInvitation>;

export const deleteInvitationTicketingUser = (
  payload: TDeleteInvitationTicketingUserPayload
): Promise<TDeleteInvitationTicketingUserResponse> => {
  const url = `/invitation-ticketing/${payload.invitationId}`;

  return axiosInstance.delete(url);
};

/**
 * Use Delete Invitation Ticketing User React-Query Hook
 */
type UseDeleteInvitationTicketingUserMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof deleteInvitationTicketingUser, AxiosErrorCustom>;
};

export const useDeleteInvitationTicketingUserMutation = ({
  mutationConfig,
}: UseDeleteInvitationTicketingUserMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: deleteInvitationTicketingUser,
    ...restConfig,
  });
};
